// extracted by mini-css-extract-plugin
export default {"fillWidth":"Home_fillWidth__7xPZX","videocontainer":"Home_videocontainer__a877w"};